import { useEffect, useState } from "react";
import { FileText, FolderOpen } from "lucide-react";
import { api } from "@/lib/api";
import { useWorkspace } from "@/context/WorkspaceContext";

const IMAGE_KINDS = ["image", "screenshot", "logo"];

// Uploaded files are private to the workspace, so they are fetched with the session and shown as blob URLs.
export function useAssetSrc(asset) {
  const { path } = useWorkspace();
  const [src, setSrc] = useState(asset?.storage_path ? null : asset?.url || null);
  useEffect(() => {
    if (!asset?.storage_path || !asset.content_type?.startsWith("image/")) return undefined;
    let url; let alive = true;
    const load = (tries) => api.get(path(`/assets/${asset.id}/file`), { responseType: "blob" })
      .then((r) => { url = URL.createObjectURL(r.data); if (alive) setSrc(url); })
      .catch(() => { if (alive && tries > 0) setTimeout(() => load(tries - 1), 1500); else if (alive) setSrc(null); });
    load(2);
    return () => { alive = false; if (url) URL.revokeObjectURL(url); };
  }, [asset?.id, asset?.storage_path, asset?.content_type, path]);
  return src;
}

export function AssetThumb({ asset, className = "" }) {
  const src = useAssetSrc(asset);
  const isImage = asset?.storage_path ? asset.content_type?.startsWith("image/") : IMAGE_KINDS.includes(asset?.kind) && asset?.url;
  return (
    <div className={`bg-[#050816] flex items-center justify-center overflow-hidden ${className}`}>
      {isImage && src ? <img src={src} alt={asset.name} className="w-full h-full object-cover" />
        : asset?.content_type === "application/pdf" ? <FileText className="text-[#3A4870]" /> : <FolderOpen className="text-[#3A4870]" />}
    </div>
  );
}

export async function downloadAsset(path, asset) {
  const r = await api.get(path(`/assets/${asset.id}/file`), { responseType: "blob" });
  const url = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = url; a.download = asset.original_filename || asset.name; a.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
